import React, { useEffect, useRef } from 'react';
import '../css/Wallet.css'; 
import WaveSeparator from "../components/WaveSeparator"; 
import linuxIcon from '../assets/wallet-linux.png'; 
import windowsIcon from '../assets/wallet-win.png'; 
import macIcon from '../assets/wallet-mac.png'; 
import webIcon from '../assets/wallet-web.png'; 


const Wallet = () => {
    const walletRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('in-view');
                    }
                });
            },
            { threshold: 0.1 }
        );

        walletRefs.current.forEach((ref) => {
            if (ref) {
                observer.observe(ref);
            }
        });

        return () => {
            walletRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    return (
        <section id="wallet-section" className="wallet-section">
            <h1>Our Wallets</h1>
            <h2>Available for Linux, Windows, Mac, and Web.</h2>
            <div className="wallet-features">
                {/* Ligne 1 */}
                <div className="wallet-row">
                    <div className="wallet-item slide-left" ref={(el) => (walletRefs.current[0] = el)}>
                        <h3>Linux Wallet</h3>
                        <a href="https://github.com/AidpProject/Aidpcoin/releases/download/v1.0.1/aidp-qt-x86_64-linux.tar.xz" target="_blank" rel="noopener noreferrer">
                            <img src={linuxIcon} alt="Linux Wallet" className="wallet-icon" />
                        </a>
                        <a href="https://github.com/AidpProject/Aidpcoin/releases/download/v1.0.1/aidp-qt-x86_64-linux.tar.xz" className="cta-button">Download</a>
                    </div>
                    <div className="wallet-item slide-right" ref={(el) => (walletRefs.current[1] = el)}>
                        <h3>Windows Wallet</h3>
                        <a href="https://github.com/AidpProject/Aidpcoin/releases/download/v1.0.1/aidp-qt-win64.zip" target="_blank" rel="noopener noreferrer">
                            <img src={windowsIcon} alt="Windows Wallet" className="wallet-icon" />
                        </a>
                        <a href="https://github.com/AidpProject/Aidpcoin/releases/download/v1.0.1/aidp-qt-win64.zip" className="cta-button">Download</a>
                    </div>
                    <div className="wallet-item slide-left" ref={(el) => (walletRefs.current[2] = el)}>
                        <h3>Mac Wallet</h3>
                        <a href="https://github.com/AidpProject/Aidpcoin/releases/download/v1.0.1/aidp-qt-osx64.tgz" target="_blank" rel="noopener noreferrer">
                            <img src={macIcon} alt="Mac Wallet" className="wallet-icon" />
                        </a>
                        <a href="https://github.com/AidpProject/Aidpcoin/releases/download/v1.0.1/aidp-qt-osx64.tgz" className="cta-button">Download</a>
                    </div>
                    <div className="wallet-item slide-right" ref={(el) => (walletRefs.current[3] = el)}>
                        <h3>Web Wallet</h3>
                        <a href="https://webwallet.ai-depin.org/" target="_blank" rel="noopener noreferrer">
                            <img src={webIcon} alt="Web Wallet" className="wallet-icon" />
                        </a>
                        <a href="https://webwallet.ai-depin.org/" className="cta-button">GO</a>
                    </div>
                </div>
            </div>
            {/* Intégration de WaveSeparator ici */}
            <WaveSeparator />
        </section>
    );
};

export default Wallet;
